import { SearchDateTerms } from 'types/common/searchfilter';
import { DateTime } from 'luxon';

export const TODAY_FOR_SUBSCRIPTION = DateTime.now().toUTC().toFormat('yyyy-MM-dd');

export const subscriptionTerms = {
  [SearchDateTerms['1_MONTH']]: { month: 1, day: 0 },
  [SearchDateTerms['3_MONTHS']]: { month: 3, day: 0 },
  [SearchDateTerms['1_YEAR']]: { year: 1, month: 0, day: 0 },
};

export const getRangePickerMappingDates = ({
  startDate,
  subscriptionTerms,
}: {
  startDate: string;
  subscriptionTerms: any;
}) => {
  return DateTime.fromFormat(startDate, 'yyyy-MM-dd')
    .toUTC()
    .plus({ ...subscriptionTerms })
    .toUTC()
    .toFormat('yyyy-MM-dd');
};
